import { ExitAnimationFunction } from '@/features/common/components/Toast/types'
import { ExitAnimationsValues } from 'react-native-reanimated'

export const NoopExiting: ExitAnimationFunction = (values: ExitAnimationsValues) => {
    'worklet'

    return {
        animations: {
            originX: values.currentOriginX,
            originY: values.currentOriginY,
            width: values.currentWidth,
            height: values.currentHeight,
        },
        initialValues: {
            originX: values.currentOriginX,
            originY: values.currentOriginY,
            width: values.currentWidth,
            height: values.currentHeight,
        },
    }
}
